import { InputAdornment as MuiInputAdornment, InputAdornmentProps } from '@mui/material';

export const InputAdornment = (props: InputAdornmentProps) => <MuiInputAdornment {...props} />;
